import { render, staticRenderFns } from "./UserRightsCopier.vue?vue&type=template&id=54d7c18c&scoped=true"
import script from "./UserRightsCopier.vue?vue&type=script&lang=ts"
export * from "./UserRightsCopier.vue?vue&type=script&lang=ts"
import style0 from "./UserRightsCopier.vue?vue&type=style&index=0&id=54d7c18c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d7c18c",
  null
  
)

export default component.exports